import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react'
import { memo } from 'react';
import { Col, Row } from 'react-bootstrap';
import { formatDate } from '../../utils';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

const iconsMap: Record<string, IconDefinition> = {
  dataset: solid('database'),
  model: solid('graduation-cap'),
  batch: solid('code'),
  source: solid('sign-out-alt'),
  processor: solid('cog'),
  sink: solid('sign-in-alt'),
}

type Props = {
  title: string;
  name?: string;
  type: string;
  version?: string;
  trailing?: string;
}

function NodeContent({ title, name, type, version, trailing }: Props) {
  return (
    <Row className="gx-0 align-items-center">
      <div className="w-auto">
        <FontAwesomeIcon icon={iconsMap[type] || solid('cog')} />
      </div>
      <Col className="px-2 text-center overflow-hidden">
        <div className="node-title text-truncate">{title}</div>
        {trailing && <small className="node-trailing text-truncate">{formatDate(trailing)}</small>}
        {(type === "batch" || type === "source" || type === "processor" || type === "sink") && version && (
          <small className="node-trailing text-truncate">
            <FontAwesomeIcon icon={solid('tag')} />
            <span className="ms-2">{name}{name !== undefined && " "}{version}</span>
          </small>
        )}
      </Col>
    </Row>
  )
}

export default memo(NodeContent);
